import { Rows2Icon, Rows3Icon, Rows4Icon } from "lucide-react";
import { Segment } from "../Segment";
import { SegmentItem } from "../Segment/types";
import { useTableContext } from "./context";
import type { RowDensityValue } from "./types";

export const RowDensity = () => {
  const { rowDensity } = useTableContext();

  const items: SegmentItem[] = [
    {
      id: "expanded",
      text: <Rows2Icon size={14} />,
      className: "w-7 p-0 shrink-0",
    },
    {
      id: "default",
      text: <Rows3Icon size={14} />,
      className: "w-7 p-0 shrink-0",
    },
    {
      id: "dense",
      text: <Rows4Icon size={14} />,
      className: "w-7 p-0 shrink-0",
    },
  ];

  const handleChange = (value: string) => {
    rowDensity.onChange(value as RowDensityValue);
  };

  if (!rowDensity.show) {
    return null;
  }

  return (
    <div>
      <Segment
        items={items}
        activeItem={rowDensity.value}
        onChange={handleChange}
        className="h-8"
      />
    </div>
  );
};
